import { InjectionToken } from '@angular/core';
import { BaseApiClientAssessmentService } from '../base-api-client-assessment.service';

export const API_CLIENT_ASSESSMENTS_SERVICE = new InjectionToken<BaseApiClientAssessmentService>(
  'BaseApiClientAssessmentService'
);